import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const BASE =
  "group inline-flex items-center justify-center gap-3 px-7 py-4 font-tech text-[11px] uppercase tracking-[0.2em] transition-[background-color,color,border-color] duration-300";

export function BtnPrimary({ to, href, children, testid, className = "", onClick }) {
  const cls = `${BASE} bg-molten text-ink hover:bg-molten-hot ${className}`;
  const icon = (
    <ArrowUpRight className="size-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  );
  if (to)
    return (
      <Link to={to} data-testid={testid} className={cls} onClick={onClick}>
        {children}
        {icon}
      </Link>
    );
  return (
    <a href={href} data-testid={testid} className={cls} onClick={onClick}>
      {children}
      {icon}
    </a>
  );
}

export function BtnGhost({ to, href, children, testid, className = "", onClick }) {
  const cls = `${BASE} border border-white/25 text-white hover:border-molten hover:text-molten ${className}`;
  if (to)
    return (
      <Link to={to} data-testid={testid} className={cls} onClick={onClick}>
        {children}
      </Link>
    );
  return (
    <a href={href} data-testid={testid} className={cls} onClick={onClick}>
      {children}
    </a>
  );
}
